import { OperatorPerformanceBucket } from '@hakimo-ui/hakimo/types';
import dayjs from 'dayjs';
import { METRICS } from './metrics';

interface EscalationMarkerProps {
  x: number;
  y: number;
  count: number;
}

export function EscalationMarker(props: EscalationMarkerProps) {
  const { x, y, count } = props;

  return (
    <g transform={`translate(${x}, ${y})`}>
      <circle r={7} className="fill-amber-500" />
      <text
        dy="0.35em"
        textAnchor="middle"
        className="fill-gray-900 text-[9px] font-semibold"
      >
        {count}
      </text>
    </g>
  );
}

interface TrendTooltipProps {
  bucket: OperatorPerformanceBucket;
  resolutionMinutes: number;
  left: number;
  alignLeft: boolean;
}

export function TrendTooltip(props: TrendTooltipProps) {
  const { bucket, resolutionMinutes, left, alignLeft } = props;
  const start = dayjs(bucket.windowStart);

  return (
    <div
      className="border-onlight-line-3 dark:border-ondark-line-3 bg-onlight-bg-1 dark:bg-ondark-bg-1 pointer-events-none absolute top-1 z-10 flex flex-col gap-0.5 whitespace-nowrap rounded-md border px-2.5 py-2 text-xs shadow-lg"
      style={{
        left,
        transform: alignLeft
          ? 'translateX(calc(-100% - 8px))'
          : 'translateX(8px)',
      }}
    >
      <span className="text-onlight-text-2 dark:text-ondark-text-2">
        {start.format('HH:mm')} –{' '}
        {start.add(resolutionMinutes, 'minute').format('HH:mm')}
      </span>
      {METRICS.map((metric) => (
        <span key={metric.key} className="flex items-center gap-2">
          <span className={metric.swatchClass} />
          <span className="text-onlight-text-2 dark:text-ondark-text-2 flex-1">
            {metric.label}
          </span>
          <span className="text-onlight-text-1 dark:text-ondark-text-1 font-semibold">
            {bucket[metric.key]}
          </span>
        </span>
      ))}
    </div>
  );
}
